
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparepeorates",
      function () {
        return require("private-next-pages/comparepeorates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparepeorates"])
      });
    }
  